import type { Stored, StrapiDocument } from '@/types/strapi.ts'
import type { UploadedMediaValue } from '@/types/global.ts'
import type { Format } from '@/types/formats.ts'

export type InstitutionFunction =
    'ORGANIZED_BY' | 'CONDUCTED_BY' | 'COOPERATING_WITH' | 'PART_OF' | 'FUNDED_BY' | 'FUNDED_FROM'

// Own organization can additionally hold the combined role, which is never selectable for other entries.
export type OwnInstitutionFunction = 'CONDUCTED_BY' | 'ORGANIZED_AND_CONDUCTED_BY'

export type FormatInstitution = StrapiDocument & {
    format: Format | string
    function: InstitutionFunction
    name: string
    url?: string | null
    logo: UploadedMediaValue
    participatesInSelection?: boolean
    position?: number
}

export type StoredFormatInstitution = Stored<FormatInstitution>

// Selectable in the add/edit entry dropdown; ORGANIZED_AND_CONDUCTED_BY is exclusive to the own org.
export const SELECTABLE_ENTRY_FUNCTIONS: InstitutionFunction[] = [
    'ORGANIZED_BY',
    'CONDUCTED_BY',
    'COOPERATING_WITH',
    'PART_OF',
    'FUNDED_BY',
    'FUNDED_FROM',
]

// "Beteiligung an der Auswahl" is only relevant for entries that can act as contact/decision partners.
export const PARTICIPATES_IN_SELECTION_FUNCTIONS: InstitutionFunction[] = [
    'ORGANIZED_BY',
    'CONDUCTED_BY',
    'COOPERATING_WITH',
    'FUNDED_BY',
]
